import config from "@/config";
import http from "@/utils/request";
export default {
	data:{
		list:{
			url:`${config.MAIN_URL}/api/v1/jwBase`,
			name:"查询基地列表",
			get:async function(params){
				return await http.get(this.url,params);
			},
		},
		save:{
			url:`${config.MAIN_URL}/api/v1/jwBase`,
			name:"新增基地",
			post:async function(params){
				return await http.post(this.url,params);
			},
		},
		edit:{
			url:`${config.MAIN_URL}/api/v1/jwBase`,
			name:"新增基地",
			put:async function(params){
				return await http.put(this.url,params);
			},
		},
		delete:{
			url:`${config.MAIN_URL}/api/v1/jwBase`,
			name:"删除基地",
			delete:async function(params){
				return await http.delete(this.url+params);
			},
		}
	}
}
